import { removeActiveAccount, removeApiToken } from '~/utils/cookie'
import { isLoginFlowPath, isValidReturnUrl } from '~/utils/return'

export function getRequestPathname (url) {
  if (!url) {
    return ''
  }

  try {
    if (/^https?:\/\//i.test(url)) {
      return new URL(url).pathname
    }

    return url.split('?')[0]
  } catch (e) {
    return ''
  }
}

export function isUnauthenticatedAuthRequest (url, method = 'get') {
  const path = getRequestPathname(url)

  if (path === '/authMethods' || path === '/auth/authorize' || path === '/v2/auth/login') {
    return true
  }

  if (/^\/v2\/auth\/[^/]+\/verify-(mfa|login)$/.test(path)) {
    return true
  }

  return String(method).toLowerCase() === 'delete' && /^\/v2\/auth\/[^/]+$/.test(path)
}

export default function axiosAuthInterceptor (ctx) {
  const { $axios, redirect } = ctx

  $axios.onError((err) => {
    const requestPath = getRequestPathname(err?.request?.responseURL || err?.config?.url)

    // To prevent race-condiditions when intentionally trying to fetch
    // user profile without valid credentials (to check if they are valid)
    // we do not redirect on GET /me profile fetches.
    if (['/api/me', '/me'].includes(requestPath)) {
      return
    }

    const isUnauthorized = err?.response?.status === 401
    const isAuthRestriction = err?.response?.status === 403 && err?.response?.data?.error_type === 'auth_restrictions_not_met'

    if (!isUnauthorized && !isAuthRestriction) {
      return
    }

    const onLoginFlow = isLoginFlowPath(location.pathname)

    // Workspace auth restrictions during login should not wipe the new session
    if (isAuthRestriction && onLoginFlow) {
      return
    }

    removeApiToken()
    removeActiveAccount()

    // Login pages and login API calls handle 401s themselves. Redirecting from
    // /login/2fa (or password/choose-account) would store that page as ?return=
    // and send the user through 2FA again after they pick an account.
    if (onLoginFlow || isUnauthenticatedAuthRequest(requestPath, err?.config?.method)) {
      return
    }

    const currentUrl = new URL(location.href)
    if (currentUrl.searchParams.has('is-child-app') || !isValidReturnUrl(location.href)) {
      redirect('/login')
    } else {
      redirect(`/login?return=${encodeURIComponent(location.href)}`)
    }
  })
}
